enum LoadingState {
  None,
  Pending,
  Success,
  Error,
}

// trailer sub type
enum TrailerSubType {
  Reefer = "Reefer",
  DryVan = "DryVan",
  Dry = "Dry",
  Flatbed = "Flatbed",
  Chassis = "Chassis",
  BoxTruck = "BoxTruck",
  Container = "Container",
}

const BidStatus = {
  Pending: "pending",
  Accepted: "accepted",
  Rejected: "rejected",
  Expired: "expired",
};

export { BidStatus, LoadingState, TrailerSubType };
